import script from "./LightDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./LightDetail.vue?vue&type=script&setup=true&lang=js"

import "./LightDetail.vue?vue&type=style&index=0&id=56b2736c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b2736c"]])

export default __exports__